module.exports = __webpack_public_path__ + "static/media/home.aeea9f1c.png";